import { ActionReducerMap, INIT, MetaReducer } from '@ngrx/store';
import * as AddressReducer from './address/address.reducer';
import * as ContextReducer from './context/context.reducer';
import * as ContractReducer from './contract/contract.reducer';
import * as CrossSellingReducer from './cross-selling/cross-selling.reducer';
import { State } from './core.state';
import * as DevisReducer from './devis/devis.reducer';
import * as ElectronicSignatureReducer from './electronic-signature/electronic-signature.reducer';
import * as EndorsementReducer from './endorsement/endorsement.reducer';
import * as HousingReducer from './housing/housing.reducer';
import { hydrationMetaReducer } from './hydration/hydration.reducer';
import * as InfoReducer from './info/info.reducer';
import * as InsuredReducer from './insured/insured.reducer';
import * as OfferCustomizationReducer from './offer-customization/offer-customization.reducer';
import * as PathReducer from './path/path.reducer';
import * as PaymentReducer from './payment/payment.reducer';
import * as RoomMateReducer from './roommate/roommate.reducer';
import * as ServiceReducer from './service/service.reducer';
import * as SubscriberReducer from './subscriber/subscriber.reducer';
import * as TarificationReducer from './tarification/tarification.reducer';

export const reducers: ActionReducerMap<State> = {
  address: AddressReducer.reducer,
  path: PathReducer.reducer,
  housing: HousingReducer.reducer,
  info: InfoReducer.reducer,
  service: ServiceReducer.reducer,
  payment: PaymentReducer.reducer,
  electronicSignature: ElectronicSignatureReducer.reducer,
  subscriber: SubscriberReducer.reducer,
  context: ContextReducer.reducer,
  offerCustomization: OfferCustomizationReducer.reducer,
  roomMate: RoomMateReducer.reducer,
  tarification: TarificationReducer.reducer,
  devis: DevisReducer.reducer,
  contract: ContractReducer.reducer,
  insured: InsuredReducer.reducer,
  endorsement: EndorsementReducer.reducer,
  crossSelling: CrossSellingReducer.reducer
};

export const metaReducers: MetaReducer[] = [hydrationMetaReducer, clearState];

export function clearState(reducer: any) {
  return (state: any, action: any) => {
    if (action != null && action.type === '[Store] Reset') {
      return reducer(undefined, { type: INIT });
    }
    return reducer(state, action);
  };
}
